import { render, staticRenderFns } from "./CustomTextFieldNumber.vue?vue&type=template&id=764993f1&"
import script from "./CustomTextFieldNumber.vue?vue&type=script&lang=js&"
export * from "./CustomTextFieldNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
